// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.App {
  color: white;
}

h3 {
  margin-top: 0;
}
.App-header {
  text-align: center;
  background-color: #1a1837;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}
 
.buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 1rem;
  margin-right: 2rem;
}

.buttons button {
  background-color: #9591ce;
  border: solid #b7bdbe 1px ;
  border-radius: .2rem;
  
}
.log-on {
  display: flex;
  align-items: center;
  justify-content: center;
}
.log-on-button {
  margin-top: 3rem;
  font-size: 2rem;
  padding: .5rem;
  background-color: #9591ce;
  border: solid #b7bdbe 1px ;
  border-radius: .5rem;
 
}
.period-select {
  display: flex;
  margin-bottom: .3rem;
}

.period-name {
  margin: 0 .3rem;
}

.account-list {
  display: flex;
}

.waiting-for-data {
  text-align: center;
}

.project-button {
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  color:#b7b4de;
  text-decoration: underline;
  cursor: pointer;
}

.pdf-csv-close-button {
  text-align: left;
  background: none;
  border: none;
  padding: .5rem;
  color:#b7b4de;
  text-decoration: underline;
  cursor: pointer;
}


.modal {
  position: fixed;
  padding-top: 5px;
  z-index: 1;
  width: 40%;
  margin: auto;
  left: 0;
  right: 0;
  top:20rem;
}

.modal-content {
  border: solid;
  border-radius: 1rem;
  padding: 1rem;
  background-color: #282552;
  
}

.buttons-container {
  display: flex;
  justify-content:space-between;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;;AAEtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;;AAEtB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;;AAE3B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B","sourcesContent":["\n.App {\n  color: white;\n}\n\nh3 {\n  margin-top: 0;\n}\n.App-header {\n  text-align: center;\n  background-color: #1a1837;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n \n.buttons {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-top: 1rem;\n  margin-right: 2rem;\n}\n\n.buttons button {\n  background-color: #9591ce;\n  border: solid #b7bdbe 1px ;\n  border-radius: .2rem;\n  \n}\n.log-on {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.log-on-button {\n  margin-top: 3rem;\n  font-size: 2rem;\n  padding: .5rem;\n  background-color: #9591ce;\n  border: solid #b7bdbe 1px ;\n  border-radius: .5rem;\n \n}\n.period-select {\n  display: flex;\n  margin-bottom: .3rem;\n}\n\n.period-name {\n  margin: 0 .3rem;\n}\n\n.account-list {\n  display: flex;\n}\n\n.waiting-for-data {\n  text-align: center;\n}\n\n.project-button {\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 0;\n  color:#b7b4de;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.pdf-csv-close-button {\n  text-align: left;\n  background: none;\n  border: none;\n  padding: .5rem;\n  color:#b7b4de;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n\n.modal {\n  position: fixed;\n  padding-top: 5px;\n  z-index: 1;\n  width: 40%;\n  margin: auto;\n  left: 0;\n  right: 0;\n  top:20rem;\n}\n\n.modal-content {\n  border: solid;\n  border-radius: 1rem;\n  padding: 1rem;\n  background-color: #282552;\n  \n}\n\n.buttons-container {\n  display: flex;\n  justify-content:space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
